import { Component, OnInit } from "@angular/core";
import { AuthService } from "@shared/auth/auth.service";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";



@Component({
  selector: 'app-masterTables',
  templateUrl: './masterTables.component.html'
})

export class MasterTableComponent implements OnInit {

  currentTab = 0;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private authService: AuthService) { };

  ngOnInit(): void {

  }

  tabVisible(type: string): boolean {
    let reqRole = '';
    switch (type) {
      case 'evaluatorList':
      case 'pcaIndexAgency':
      case 'proficiencyTests':
      case 'specialties':
      case 'surveyors':
      case 'userList':
        {
          reqRole = 'Admin';
          break;
        }
    }

    let roles = reqRole.split(',');
    return this.authService.userHasAtLeastOneRole(roles);
  }

}
